var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    viewBox: "0 0 128 128",
    y: "0px",
    x: "0px",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    width: "200px",
    height: "200px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M42.2,14.1c-5.6,2.4-10.9,5.9-15.5,10.2l4.1,4.1c4.4,4.4,11,5.4,16.5,2.7c4.6-2.3,9.6-3.6,14.8-3.8 C62.2,16.9,51.7,10,42.2,14.1z",
    style: {
      fill: "rgb(52, 107, 33)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1,85.8c2.4,5.6,5.9,10.9,10.2,15.5l4.1-4.1c4.4-4.4,5.4-11,2.7-16.5c-2.3-4.6-3.6-9.6-3.8-14.8 C16.9,65.8,10,76.3,14.1,85.8z",
    style: {
      fill: "rgb(52, 107, 33)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.9,42.2c-2.4-5.6-5.9-10.9-10.2-15.5l-4.1,4.1c-4.4,4.4-5.4,11-2.7,16.5c2.3,4.6,3.6,9.6,3.8,14.8 C111.1,62.2,118,51.7,113.9,42.2z",
    style: {
      fill: "rgb(52, 107, 33)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8,113.9c5.6-2.4,10.9-5.9,15.5-10.2l-4.1-4.1c-4.4-4.4-11-5.4-16.5-2.7c-4.6,2.3-9.6,3.6-14.8,3.8 C65.8,111.1,76.3,118,85.8,113.9z",
    style: {
      fill: "rgb(52, 107, 33)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8,36.7c-3.8-3.6-8.3-6.1-13.2-7.7c-5.9-1.9-9.9-7.4-9.9-13.6V9.6C72.1,9.9,78.2,11,84,13.3 C93.4,17,96.1,29.4,88.8,36.7z",
    style: {
      fill: "rgb(148, 209, 55)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3,44C11,49.8,9.9,55.9,9.6,62.2h5.8c6.1,0,11.6-4,13.6-9.9c1.7-4.9,4.2-9.3,7.8-13.2 C29.4,31.9,17,34.6,13.3,44z",
    style: {
      fill: "rgb(148, 209, 55)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.7,84c2.3-5.8,3.5-11.9,3.7-18.2h-5.8c-6.1,0-11.6,4-13.6,9.9c-1.7,4.9-4.2,9.3-7.8,13.2 C98.6,96.1,111,93.4,114.7,84z",
    style: {
      fill: "rgb(148, 209, 55)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,114.7c5.8,2.3,11.9,3.5,18.2,3.7v-5.8c0-6.1-4-11.6-9.9-13.6c-4.9-1.7-9.3-4.2-13.2-7.8 C31.9,98.6,34.6,111,44,114.7z",
    style: {
      fill: "rgb(148, 209, 55)"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.c5ba412d1d985c488fb0a79875683ed0.svg";
export { ForwardRef as ReactComponent };